import React from "react";
import "../commanComponents.css";

export default function ColorBtn({ text, onClick, icon, style, dataTooltipId, onMouseEnter, bgColor, color, padding, disabled }) {
  return (
    <div>
      <button className="colorBtn" disabled={disabled} onClick={onClick} style={{ ...style, backgroundColor: bgColor, color: color, padding }} data-tooltip-id={dataTooltipId} onMouseEnter={onMouseEnter}>
        <div>{icon}</div>
        {text}
      </button>
    </div>
  );
}
